import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import { addOnDefSchema } from './entities';

export const types = {
  CREATE_ADD_ON_ERROR: 'addOns/listPage/CREATE_ADD_ON_ERROR',
  CREATE_ADD_ON_REQUEST: 'addOns/listPage/CREATE_ADD_ON_REQUEST',
  CREATE_ADD_ON_SUCCESS: 'addOns/listPage/CREATE_ADD_ON_SUCCESS',
  NEW_ADD_ON_MODAL_CLOSE: 'addOns/listPage/NEW_ADD_ON_MODAL_CLOSE',
  NEW_ADD_ON_MODAL_OPEN: 'addOns/listPage/NEW_ADD_ON_MODAL_OPEN',
  RECEIVE_ADD_ON_DEFINITIONS: 'addOns/listPage/RECEIVE_ADD_ON_DEFINITIONS',
};

export const createAddOn = {
  error: notify(
    (error) => ({
      type: types.CREATE_ADD_ON_ERROR,
      payload: error,
    }),
    'Failed to create Add-On',
  ),
  request: (payload) => ({
    type: types.CREATE_ADD_ON_REQUEST,
    payload,
  }),
  success: ({ addOn }) => ({
    type: types.CREATE_ADD_ON_SUCCESS,
    payload: normalize(addOn, addOnDefSchema),
  }),
};

export const newAddOnModal = {
  close: () => ({
    type: types.NEW_ADD_ON_MODAL_CLOSE,
  }),
  open: () => ({
    type: types.NEW_ADD_ON_MODAL_OPEN,
  }),
};

export const entities = {
  recieveAddOnDefs: ({ addOnDefs }) => ({
    type: types.RECEIVE_ADD_ON_DEFINITIONS,
    payload: normalize(addOnDefs, [addOnDefSchema]),
  }),
};
